import { ValueOfKey } from '../../utils-types';

export const VERIFICATION_CHANNEL = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
} as const;

export type VerificationChannel = ValueOfKey<typeof VERIFICATION_CHANNEL>;
